
<template>
  <!-- Navbar -->
  <header class="navbar navbar-expand-md d-print-none">
    <div class="container-xl">
      <button class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbar-menu"
        aria-controls="navbar-menu" aria-expanded="false" aria-label="Toggle navigation">
        <span class="navbar-toggler-icon"></span>
      </button>
      <h1 class="navbar-brand navbar-brand-autodark d-none-navbar-horizontal pe-0 pe-md-3">
        <a href=".">
          <img src="/img/logo.png" width="110" height="32" alt="Tabler" class="navbar-brand-image"> 智能管家
        </a>
      </h1>
      <div class="navbar-nav flex-row order-md-last">
        <div class="d-none d-md-flex">
          <div @click="handTheme" class="nav-link px-10 hide-theme-dark themeModeChange" data-bs-toggle="tooltip"
            data-bs-placement="bottom" aria-label="Enable dark mode" data-bs-original-title="Enable dark mode">
            <i class="fa-2x fa-duotone fa-moon-stars"></i>
          </div>
          <div @click="handTheme" class="nav-link px-10 hide-theme-light themeModeChange" data-bs-toggle="tooltip"
            data-bs-placement="bottom" aria-label="Enable light mode" data-bs-original-title="Enable light mode">
            <i class="fa-2x fa-duotone fa-sun-bright"></i>
          </div>

        </div>
        <div class="nav-item dropdown">
          <a href="#" class="nav-link d-flex lh-1 text-reset p-0" data-bs-toggle="dropdown" aria-label="Open user menu">
            <span class="avatar" :style="{ backgroundImage: 'url(' + global.userinfo.avatar + ')' }">{{ getAvarat()
            }}</span>
          </a>
          <div class="dropdown-menu dropdown-menu-end dropdown-menu-arrow">
            <a href="#" class="dropdown-item" @click.prevent="signoutBtn">退出登录</a>

          </div>
        </div>
      </div>
    </div>
  </header>
</template>
<script>
import { global } from '../global.js'
export default {
  name: 'HomerBlock',
  data() {
    return {
      global: global,
    };
  }, methods: {
    getAvarat: function () {
      if (global.userinfo.avatar != "") return ""
      if (global.userinfo.nickname != "") return global.userinfo.nickname.substring(0, 2);
      return (global.userinfo.telphone != "" ? global.userinfo.telphone : global.userinfo.email).substring(0, 2);
    },
    signoutBtn: function () {
      localStorage.removeItem("userinfo");
      this.$router.push('/signin')
    },
    formatAccount(val) {
      let vals = val.split('@');
      return vals[0].toUpperCase();
    },
    getPrefersColorScheme: function () {
      return window.matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'light'
    },
    getTheme: function () {
      var themeStorageKey = "tablerTheme";
      const theme = localStorage.getItem(themeStorageKey)
      if (theme != null) {
        return theme
      } else {
        return this.getPrefersColorScheme();
      }
    },
    autoTheme: function () {
      if (this.getTheme() === 'dark') {
        document.body.setAttribute('data-bs-theme', 'dark')
      } else {
        document.body.removeAttribute('data-bs-theme')
      }
    },
    handTheme: function () {
      var currentTheme = this.getTheme();
      localStorage.setItem("tablerTheme", currentTheme == "dark" ? "light" : "dark");
      this.autoTheme();
    },
    listenTheme: function () {
      const mediaQueryList = window.matchMedia('(prefers-color-scheme: dark)');
      mediaQueryList.addEventListener('change', () => {
        this.autoTheme();
      })
    }
  }, created() {
    this.autoTheme();
    this.listenTheme();
  }
}
</script>
<style scoped>
.themeModeChange {
  cursor: pointer;
}
</style>